import { Component } from '@angular/core'
import { Observable } from 'rxjs'
import { Store } from '@ngrx/store'
import { AppState } from './state/app-state'
import { AuthService } from './services/auth/auth.service'
import { IGlobals } from './models/landingpage/globals'
import { Router, NavigationEnd } from '@angular/router'
import { filter } from 'rxjs/operators'
import { SchemaService } from './schema.service'

declare global {
	interface Window {
		ga: any
		pintrk: any
		dataLayer: any
		gtag: any
		uetq: any
	}
}

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent {
	private loading$?: Observable<boolean>
	private globals$?: Observable<IGlobals>
	loading?: boolean
	globals?: IGlobals
	activeFormulaE = false
    isIframePage = false

	constructor(
		private authService: AuthService,
		private store: Store<AppState>,
		private router: Router,
		private schemaService: SchemaService
	) {
		this.loading$ = this.store.select('loading')
		this.loading$.subscribe((state) => {
			this.loading = state
		})
	}

	ngOnInit(): void {
		if (window.location.pathname === '/formulae') {
			this.activeFormulaE = true
		}

		this.router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.subscribe((event: any) => {
				const url = event.urlAfterRedirects
				const canonicalUrl = `https://cote.allianz.com.br${url}`
				this.updateCanonicalTag(canonicalUrl)
                this.isIframePage = url.includes('iframe') || url.includes('transporte')

				if (url === '/') {
					this.schemaService.addSchema({
						"@context": "https://schema.org",
                        "@graph": [
                            {
                                "@type": "WebPage",
                                "@id": "https://cote.allianz.com.br/#webpage",
                                "url": "https://cote.allianz.com.br/",
                                "name": "Cotação de Seguro Online: Auto, Vida, Residencial e Empresarial",
                                "description": "Peça sua cotação de seguro online agora mesmo. Oferecemos assistência 24h, proteção contra roubo, danos elétricos e muito mais. Conheça nossas coberturas!",
                                "inLanguage": "pt-BR",
                                "image": {
                                    "@id": "https://cote.allianz.com.br/#imageprincipal"
                                }
                            },
                            {
                                "@type": "ImageObject",
                                "@id": "https://cote.allianz.com.br/#imageprincipal",
                                "url": "https://s3.amazonaws.com/prod-back-cote-allianz/CMS-cote-allianz/88301068-ca9e-482b-b018-cbdf7664e1c6.png",
                                "caption": "Cotação de Seguro Online Allianz"
                            },
                            {
                                "@type": "Service",
                                "@id": "https://cote.allianz.com.br/#service",
                                "name": "Cotação de Seguro Online Allianz",
                                "description": "Solicite online sua cotação de Seguro Auto, Residencial, Vida e Empresarial com a Allianz de forma rápida e prática.",
                                "provider": {
                                    "@type": "Organization",
                                    "name": "Allianz Seguros Brasil",
                                    "url": "https://www.allianz.com.br"
                                },
                                "areaServed": {
                                    "@type": "Country",
                                    "name": "Brasil"
                                },
                                "serviceType": "Cotação de Seguro Online",
                                "offers": {
                                    "@type": "Offer",
                                    "url": "https://cote.allianz.com.br/",
                                    "price": "0.00",
                                    "priceCurrency": "BRL",
                                    "availability": "https://schema.org/InStock",
                                    "priceValidUntil": "2026-12-31"
                                },
                                "image": "https://s3.amazonaws.com/prod-back-cote-allianz/CMS-cote-allianz/88301068-ca9e-482b-b018-cbdf7664e1c6.png"
                            },
                            {
                                "@type": "Product",
                                "@id": "https://cote.allianz.com.br/#product",
                                "name": "Cotação de Seguro Online Allianz",
                                "description": "Peça sua cotação de seguro online agora mesmo. Oferecemos assistência 24h, proteção contra roubo, danos elétricos e muito mais. Conheça nossas coberturas!",
                                "brand": {
                                    "@type": "Brand",
                                    "name": "Allianz Seguros"
                                },
                                "aggregateRating": {
                                    "@type": "AggregateRating",
                                    "ratingValue": "4.8",
                                    "reviewCount": "17579"
                                },
                                "offers": {
                                    "@type": "Offer",
                                    "url": "https://cote.allianz.com.br/",
                                    "price": "0.00",
                                    "priceCurrency": "BRL",
                                    "availability": "https://schema.org/InStock",
                                    "priceValidUntil": "2026-12-31"
                                },
                                "image": "https://s3.amazonaws.com/prod-back-cote-allianz/CMS-cote-allianz/88301068-ca9e-482b-b018-cbdf7664e1c6.png"
                            },
                            {
                                "@type": "BreadcrumbList",
                                "@id": "https://cote.allianz.com.br/#breadcrumb",
                                "itemListElement": [
                                    {
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "Cotação de Seguro Online",
                                    "item": "https://cote.allianz.com.br/"
                                    }
                                ]
                            },
                            {
                                "@type": "FAQPage",
                                "@id": "https://cote.allianz.com.br/#faq",
                                "mainEntity": [
                                    {
                                    "@type": "Question",
                                    "name": "Como funciona a Cotação de Seguro Online da Allianz?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "Para solicitar uma cotação de seguro online, escolha qual seguro Allianz você deseja cotar: Auto, Residencial, Vida ou Empresarial. Depois, preencha os campos do formulário com alguns dados pessoais e outras informações sobre o seguro escolhido. Após finalizar o preenchimento e enviar seus dados, em até 1 dia útil um corretor parceiro da Allianz entrará em contato para te apresentar a melhor oferta de seguro."
                                    }
                                    },
                                    {
                                    "@type": "Question",
                                    "name": "Quais seguros da Allianz é possível cotar online?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "Você pode fazer uma cotação online de Seguro Auto, incluindo carro, moto e caminhão, Seguro Residencial para sua casa ou apartamento, Seguro Empresarial para empresas PME e Seguro de Vida."
                                    }
                                    },
                                    {
                                    "@type": "Question",
                                    "name": "É possível contratar mais de um seguro?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "Sim. Combinar seguros pode ampliar sua proteção contra imprevistos que podem afetar seu patrimônio, sua mobilidade ou sua família."
                                    }
                                    }
                                ]
                            }
                        ]
					})
				} else if (url.startsWith('/auto')) {
					this.schemaService.addSchema({
						"@context": "https://schema.org",
                        "@graph": [
                            {
                                "@type": "WebPage",
                                "@id": "https://cote.allianz.com.br/auto#webpage",
                                "url": "https://cote.allianz.com.br/auto",
                                "name": "Seguro Auto | Allianz Brasil",
                                "description": "Faça sua cotação de seguro online e sem burocracia. Oferecemos assistência 24h, proteção contra roubo, danos elétricos e muito mais. Conheça nossas coberturas!",
                                "inLanguage": "pt-BR",
                                "image": {
                                    "@id": "https://cote.allianz.com.br/auto#imageprincipal"
                                }
                            },
                            {
                                "@type": "ImageObject",
                                "@id": "https://cote.allianz.com.br/auto#imageprincipal",
                                "url": "https://s3.amazonaws.com/prod-back-cote-allianz/CMS-cote-allianz/bba75c95-4694-47b7-b123-19c89df80244.jpg",
                                "caption": "Seguro Auto Allianz – Cotação Online"
                            },
                            {
                                "@type": "Service",
                                "@id": "https://cote.allianz.com.br/auto#service",
                                "name": "Seguro Auto Allianz",
                                "description": "Seguro Auto da Allianz com proteção completa, incluindo assistência 24h, roubo, colisão, danos elétricos e serviços adicionais.",
                                "provider": {
                                    "@type": "Organization",
                                    "name": "Allianz Seguros Brasil",
                                    "url": "https://www.allianz.com.br"
                                },
                                "areaServed": {
                                    "@type": "Country",
                                    "name": "Brasil"
                                },
                                "serviceType": "Seguro Auto",
                                "offers": {
                                    "@type": "Offer",
                                    "url": "https://cote.allianz.com.br/auto",
                                    "price": "0.00",
                                    "priceCurrency": "BRL",
                                    "availability": "https://schema.org/InStock",
                                    "priceValidUntil": "2026-12-31"
                                },
                                "image": "https://s3.amazonaws.com/prod-back-cote-allianz/CMS-cote-allianz/bba75c95-4694-47b7-b123-19c89df80244.jpg"
                            },
                            {
                                "@type": "Product",
                                "@id": "https://cote.allianz.com.br/auto#product",
                                "name": "Seguro Auto Allianz",
                                "description": "Proteção completa para seu veículo, com coberturas contra colisão, roubo, danos elétricos e assistência 24h.",
                                "brand": {
                                    "@type": "Brand",
                                    "name": "Allianz Seguros"
                                },
                                "aggregateRating": {
                                    "@type": "AggregateRating",
                                    "ratingValue": "4.8",
                                    "reviewCount": "17579"
                                },
                                "offers": {
                                    "@type": "Offer",
                                    "url": "https://cote.allianz.com.br/auto",
                                    "price": "0.00",
                                    "priceCurrency": "BRL",
                                    "availability": "https://schema.org/InStock",
                                    "priceValidUntil": "2026-12-31"
                                },
                                "image": "https://s3.amazonaws.com/prod-back-cote-allianz/CMS-cote-allianz/bba75c95-4694-47b7-b123-19c89df80244.jpg"
                            },
                            {
                                "@type": "BreadcrumbList",
                                "@id": "https://cote.allianz.com.br/auto#breadcrumb",
                                "itemListElement": [
                                    {
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "Cotação de Seguro Online",
                                    "item": "https://cote.allianz.com.br/"
                                    },
                                    {
                                    "@type": "ListItem",
                                    "position": 2,
                                    "name": "Cotação de Seguro Auto",
                                    "item": "https://cote.allianz.com.br/auto"
                                    }
                                ]
                            },
                            {
                                "@type": "FAQPage",
                                "@id": "https://cote.allianz.com.br/auto#faq",
                                "mainEntity": [
                                    {
                                    "@type": "Question",
                                    "name": "Como funciona a cotação de seguro auto da Allianz?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "Para solicitar uma cotação de seguro auto da Allianz, você deve preencher os campos do formulário com alguns dados pessoais, além de informações sobre o veículo que você deseja cotar. Após finalizar o preenchimento e enviar seus dados, em até 1 dia útil um corretor parceiro da Allianz entrará em contato para te apresentar a melhor oferta para seu veículo."
                                    }
                                    },
                                    {
                                    "@type": "Question",
                                    "name": "Quais são as coberturas do Seguro Auto da Allianz?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "As principais coberturas do Seguro Auto da Allianz são: roubo, furto ou indenização integral; colisão; Carta Verde; até 45 dias de carro reserva; franquia 25% da normal; alagamentos e outros eventos da natureza; proteção a terceiros; cobertura para Kit Gás; acidentes pessoais de passageiros; proteção para vidros, faróis e retrovisores; assistência residencial gratuita; pequenos reparos de lataria, rodas e pneus; assistência 24h no Mercosul."
                                    }
                                    },
                                    {
                                    "@type": "Question",
                                    "name": "Quais são as assistências do Seguro Auto da Allianz?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "As assistências do Seguro Auto da Allianz são: assistência guincho com 200 km, 500 km ou quilometragem ilimitada; assistência 24h no Mercosul; assistência residencial gratuita."
                                    }
                                    }
                                ]
                            }
                        ]
					})
				}
                else if (url.startsWith('/residencia')) {
                    this.schemaService.addSchema({
                        "@context": "https://schema.org",
                        "@graph": [
                            {
                                "@type": "WebPage",
                                "@id": "https://cote.allianz.com.br/residencia#webpage",
                                "url": "https://cote.allianz.com.br/residencia",
                                "name": "Seguro Residencial | Cotação Online Allianz",
                                "description": "Faça sua cotação de Seguro Residencial Allianz online e sem burocracia. Proteção completa contra incêndio, danos elétricos, roubo e muito mais.",
                                "inLanguage": "pt-BR",
                                "image": {
                                    "@id": "https://cote.allianz.com.br/residencia#imageprincipal"
                                }
                            },
                            {
                                "@type": "ImageObject",
                                "@id": "https://cote.allianz.com.br/residencia#imageprincipal",
                                "url": "https://s3.amazonaws.com/prod-back-cote-allianz/CMS-cote-allianz/7cfe2db8-08ee-413d-ac56-facb7ca5f4f5.jpg",
                                "caption": "Seguro Residencial Allianz – Cotação Online"
                            },
                            {
                                "@type": "Service",
                                "@id": "https://cote.allianz.com.br/residencia#service",
                                "name": "Seguro Residencial Allianz",
                                "description": "Coberturas completas contra incêndio, danos elétricos, vendaval, roubo, responsabilidade civil e muito mais, com contratação online.",
                                "provider": {
                                    "@type": "Organization",
                                    "name": "Allianz Seguros Brasil",
                                    "url": "https://www.allianz.com.br"
                                },
                                "areaServed": {
                                    "@type": "Country",
                                    "name": "Brasil"
                                },
                                "serviceType": "Seguro Residencial",
                                "offers": {
                                    "@type": "Offer",
                                    "url": "https://cote.allianz.com.br/residencia",
                                    "price": "0.00",
                                    "priceCurrency": "BRL",
                                    "availability": "https://schema.org/InStock",
                                    "priceValidUntil": "2026-12-31"
                                },
                                "image": "https://s3.amazonaws.com/prod-back-cote-allianz/CMS-cote-allianz/7cfe2db8-08ee-413d-ac56-facb7ca5f4f5.jpg"
                            },
                            {
                                "@type": "Product",
                                "@id": "https://cote.allianz.com.br/residencia#product",
                                "name": "Seguro Residencial Allianz",
                                "description": "Proteção completa para residências, com coberturas flexíveis, assistência 24h e contratação online sem burocracia.",
                                "brand": {
                                    "@type": "Brand",
                                    "name": "Allianz Seguros"
                                },
                                "aggregateRating": {
                                    "@type": "AggregateRating",
                                    "ratingValue": "4.8",
                                    "reviewCount": "17579"
                                },
                                "offers": {
                                    "@type": "Offer",
                                    "url": "https://cote.allianz.com.br/residencia",
                                    "price": "0.00",
                                    "priceCurrency": "BRL",
                                    "availability": "https://schema.org/InStock",
                                    "priceValidUntil": "2026-12-31"
                                },
                                "image": "https://s3.amazonaws.com/prod-back-cote-allianz/CMS-cote-allianz/7cfe2db8-08ee-413d-ac56-facb7ca5f4f5.jpg"
                            },
                            {
                                "@type": "BreadcrumbList",
                                "@id": "https://cote.allianz.com.br/residencia#breadcrumb",
                                "itemListElement": [
                                    {
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "Cotação de Seguro Online",
                                    "item": "https://cote.allianz.com.br/"
                                    },
                                    {
                                    "@type": "ListItem",
                                    "position": 2,
                                    "name": "Cotação de Seguro Residencial",
                                    "item": "https://cote.allianz.com.br/residencia"
                                    }
                                ]
                            },
                            {
                                "@type": "FAQPage",
                                "@id": "https://cote.allianz.com.br/residencia#faq",
                                "mainEntity": [
                                    {
                                    "@type": "Question",
                                    "name": "Como funciona a cotação de Seguro Residencial da Allianz?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "Para solicitar uma cotação de seguro residencial da Allianz, você deve preencher os campos do formulário com alguns dados pessoais, além de informações sobre a casa ou apartamento. Após finalizar o preenchimento e enviar seus dados, em até 1 dia útil um corretor parceiro da Allianz entrará em contato para te apresentar a melhor oferta para seu imóvel."
                                    }
                                    },
                                    {
                                    "@type": "Question",
                                    "name": "Quais são as coberturas do Seguro Residencial da Allianz?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "As principais coberturas do Allianz Residência são: incêndio, queda de raio, explosão, queda de aeronaves e fumaça; danos elétricos; roubo e furto qualificado; roubo e furto de bens fora da residência; vendaval, furacão, ciclone, tornado e granizo; quebra de vidros, mármores e granitos; ruptura de tanques e tubulações; responsabilidade civil familiar; perda e pagamento de aluguel; joias e obras de arte; equipamentos eletrônicos; assistência 24h (Essencial, Completo e VIP); alagamento; gastos com defesa."
                                    }
                                    },
                                    {
                                    "@type": "Question",
                                    "name": "Quais são as assistências 24h do Seguro Residencial da Allianz?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "As assistências 24h do Allianz Residência incluem: pacote emergencial (hidráulica, elétrica, encanador, desentupimento e reparo elétrico); chaveiro; limpeza; transporte e guarda de móveis; vidraceiro; conserto de eletrodomésticos (linha branca e ar-condicionado); hospedagem; substituição de telhas ou cobertura provisória; troca de resistência de chuveiro; assistência bike; descarte responsável; pacote de serviços pet (cães e gatos)."
                                    }
                                    }
                                ]
                            }
                        ]
                    })
                } else if (url.startsWith('/vida')) {
                    this.schemaService.addSchema({
                        "@context": "https://schema.org",
                        "@graph": [
                            {
                                "@type": "WebPage",
                                "@id": "https://cote.allianz.com.br/vida#webpage",
                                "url": "https://cote.allianz.com.br/vida",
                                "name": "Seguro de Vida | Allianz Brasil",
                                "description": "Simule seu Seguro de Vida Allianz online e sem burocracia. Proteção financeira para você e sua família, com coberturas completas e contratação rápida.",
                                "inLanguage": "pt-BR",
                                "image": {
                                    "@id": "https://cote.allianz.com.br/vida#imageprincipal"
                                }
                            },
                            {
                                "@type": "ImageObject",
                                "@id": "https://cote.allianz.com.br/vida#imageprincipal",
                                "url": "https://s3.amazonaws.com/prod-back-cote-allianz/CMS-cote-allianz/1a03fd86-16b6-4670-b709-2c87498e975c.jpg",
                                "caption": "Seguro de Vida Allianz – Cotação Online"
                            },
                            {
                                "@type": "Service",
                                "@id": "https://cote.allianz.com.br/vida#service",
                                "name": "Seguro de Vida Allianz",
                                "description": "Seguro de Vida da Allianz com proteção financeira completa, assistência e coberturas para diversas situações, com contratação online.",
                                "provider": {
                                    "@type": "Organization",
                                    "name": "Allianz Seguros Brasil",
                                    "url": "https://www.allianz.com.br"
                                },
                                "areaServed": {
                                    "@type": "Country",
                                    "name": "Brasil"
                                },
                                "serviceType": "Seguro de Vida",
                                "offers": {
                                    "@type": "Offer",
                                    "url": "https://cote.allianz.com.br/vida",
                                    "price": "0.00",
                                    "priceCurrency": "BRL",
                                    "availability": "https://schema.org/InStock",
                                    "priceValidUntil": "2026-12-31"
                                },
                                "image": "https://s3.amazonaws.com/prod-back-cote-allianz/CMS-cote-allianz/1a03fd86-16b6-4670-b709-2c87498e975c.jpg"
                            },
                            {
                                "@type": "Product",
                                "@id": "https://cote.allianz.com.br/vida#product",
                                "name": "Seguro de Vida Allianz",
                                "description": "Proteção financeira completa para você e sua família, com coberturas flexíveis, assistência e contratação rápida online.",
                                "brand": {
                                    "@type": "Brand",
                                    "name": "Allianz Seguros"
                                },
                                "aggregateRating": {
                                    "@type": "AggregateRating",
                                    "ratingValue": "4.8",
                                    "reviewCount": "17579"
                                },
                                "offers": {
                                    "@type": "Offer",
                                    "url": "https://cote.allianz.com.br/vida",
                                    "price": "0.00",
                                    "priceCurrency": "BRL",
                                    "availability": "https://schema.org/InStock",
                                    "priceValidUntil": "2026-12-31"
                                },
                                "image": "https://s3.amazonaws.com/prod-back-cote-allianz/CMS-cote-allianz/1a03fd86-16b6-4670-b709-2c87498e975c.jpg"
                            },
                            {
                                "@type": "BreadcrumbList",
                                "@id": "https://cote.allianz.com.br/vida#breadcrumb",
                                "itemListElement": [
                                    {
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "Cotação de Seguro Online",
                                    "item": "https://cote.allianz.com.br/"
                                    },
                                    {
                                    "@type": "ListItem",
                                    "position": 2,
                                    "name": "Cotação de Seguro de Vida",
                                    "item": "https://cote.allianz.com.br/vida"
                                    }
                                ]
                            },
                            {
                                "@type": "FAQPage",
                                "@id": "https://cote.allianz.com.br/vida#faq",
                                "mainEntity": [
                                    {
                                    "@type": "Question",
                                    "name": "Como funciona a cotação de Seguro de Vida da Allianz?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "Para solicitar uma cotação de seguro de vida da Allianz, você deve preencher os campos do formulário com alguns dados pessoais. Após finalizar o preenchimento e enviar seus dados, em até 1 dia útil um corretor parceiro da Allianz entrará em contato para te apresentar a melhor oferta de seguro de vida."
                                    }
                                    },
                                    {
                                    "@type": "Question",
                                    "name": "Quais são as coberturas do Seguro de Vida da Allianz?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "As principais coberturas do Allianz Vida Individual são: cobertura para doenças graves; diagnóstico de câncer; cobertura para invalidez permanente total ou parcial por acidente; invalidez funcional permanente total por doença; cobertura por morte natural ou acidental; diária por incapacidade temporária por doença ou acidente (DIT); despesas médicas, hospitalares e odontológicas (DMHO)."
                                    }
                                    },
                                    {
                                    "@type": "Question",
                                    "name": "Quais são as assistências do Seguro de Vida da Allianz?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "As assistências do Seguro de Vida da Allianz são: assistência funeral ampliada de R$ 7.000 até R$ 15.000 (R$ 7.000 nos pacotes Simplificado e Básico; R$ 10.000 nos pacotes Essencial, Plus Master e Exclusivo; R$ 15.000 no pacote Personalizado); assistência nutricional; segunda opinião médica internacional; desconto em medicamentos; vigilância e segurança; pronto atendimento virtual; assistência residencial; pacote de serviços pet (cães e gatos); pronto atendimento virtual do Hospital Israelita Albert Einstein."
                                    }
                                    }
                                ]
                            }
                        ]
                    })
                } else if (url.startsWith('/empresarial')) {
                    this.schemaService.addSchema({
                        "@context": "https://schema.org",
                        "@graph": [
                            {
                                "@type": "WebPage",
                                "@id": "https://cote.allianz.com.br/empresarial#webpage",
                                "url": "https://cote.allianz.com.br/empresarial",
                                "name": "Seguro Empresarial | Cotação Online Allianz",
                                "description": "Faça sua cotação de Seguro Empresarial Allianz de forma rápida e online. Proteção completa para sua empresa, incluindo incêndio, roubo, danos elétricos e muito mais.",
                                "inLanguage": "pt-BR",
                                "image": {
                                    "@id": "https://cote.allianz.com.br/empresarial#imageprincipal"
                                }
                            },
                            {
                                "@type": "ImageObject",
                                "@id": "https://cote.allianz.com.br/empresarial#imageprincipal",
                                "url": "https://s3.amazonaws.com/prod-back-cote-allianz/CMS-cote-allianz/48fac388-3465-464b-8748-83c853b8e655.png",
                                "caption": "Seguro Empresarial Allianz – Cotação Online"
                            },
                            {
                                "@type": "Service",
                                "@id": "https://cote.allianz.com.br/empresarial#service",
                                "name": "Seguro Empresarial Allianz",
                                "description": "Proteção completa para empresas, com coberturas contra incêndio, danos elétricos, roubo, responsabilidade civil e muito mais. Contratação online pela plataforma Cote Allianz.",
                                "provider": {
                                    "@type": "Organization",
                                    "name": "Allianz Seguros Brasil",
                                    "url": "https://www.allianz.com.br"
                                },
                                "areaServed": {
                                    "@type": "Country",
                                    "name": "Brasil"
                                },
                                "serviceType": "Seguro Empresarial",
                                "offers": {
                                    "@type": "Offer",
                                    "url": "https://cote.allianz.com.br/empresarial",
                                    "price": "0.00",
                                    "priceCurrency": "BRL",
                                    "availability": "https://schema.org/InStock",
                                    "priceValidUntil": "2026-12-31"
                                },
                                "image": "https://s3.amazonaws.com/prod-back-cote-allianz/CMS-cote-allianz/48fac388-3465-464b-8748-83c853b8e655.png"
                            },
                            {
                                "@type": "Product",
                                "@id": "https://cote.allianz.com.br/empresarial#product",
                                "name": "Seguro Empresarial Allianz",
                                "description": "Seguro empresarial com coberturas amplas, assistência especializada e contratação online rápida e sem burocracia.",
                                "brand": {
                                    "@type": "Brand",
                                    "name": "Allianz Seguros"
                                },
                                "aggregateRating": {
                                    "@type": "AggregateRating",
                                    "ratingValue": "4.8",
                                    "reviewCount": "15544"
                                },
                                "offers": {
                                    "@type": "Offer",
                                    "url": "https://cote.allianz.com.br/empresarial",
                                    "price": "0.00",
                                    "priceCurrency": "BRL",
                                    "availability": "https://schema.org/InStock",
                                    "priceValidUntil": "2026-12-31"
                                },
                                "image": "https://s3.amazonaws.com/prod-back-cote-allianz/CMS-cote-allianz/48fac388-3465-464b-8748-83c853b8e655.png"
                            }
                        ]
                    })
                }

			})
	}

	private updateCanonicalTag(url: string) {
		let link: HTMLLinkElement | null = document.querySelector("link[rel='canonical']")

		if (link) {
			link.setAttribute('href', url)
		} else {
			link = document.createElement('link')
			link.setAttribute('rel', 'canonical')
			link.setAttribute('href', url)
			document.head.appendChild(link)
		}
	}
}
